import _ from '@/utils/lodash-optimized'

import http from '../../../../lib/http'
import { notify } from '../../../../lib/Notification/actions.js'
import * as AssessmentProxy from '../../../../lib/Proxy/assessment2.js'
import * as PatientBannerAction from '../../PatientBanner/actions.js'

export const ASSESSMENT = 'ASSESSMENT'
export const ASSESSMENT_SUCCESS = 'ASSESSMENT_SUCCESS'
export const ASSESSMENT_FAILURE = 'ASSESSMENT_FAILURE'

export const POST_MEDICATIONS = 'POST_MEDICATIONS'
export const GET_MEDICATIONS = 'GET_MEDICATIONS'
export const UPDATE_MEDICATIONS = 'UPDATE_MEDICATIONS'

export const updateMedications = payload => ({
  type: UPDATE_MEDICATIONS,
  payload
})

const mapFormToApi = formData => {
  const nestedToFlat = obj => {
    const flattened = {
      ...obj,
      name: obj.coding && obj.coding.display,
      code: obj.coding && obj.coding.code,
      system: obj.coding && obj.coding.system,
      coding: null
    }
    return _.omitBy(flattened, _.isNil)
  }

  return formData.map(item => nestedToFlat(item))
}

const mapApiToForm = response => {
  const flatToNested = obj => {
    const nested = {
      ...obj,
      coding: {
        display: obj.name,
        code: obj.code,
        system: obj.system
      },
      name: null,
      code: null,
      system: null
    }
    return _.omitBy(nested, _.isNil)
  }
  return response.map(item => flatToNested(item))
}

export const getInteractions = medications => dispatch => {
  dispatch({ type: 'GET_INTERACTIONS' })
  const ids = _.compact(medications.map(m => m.code))

  if (ids && ids.length >= 2) {
    return http
      .getRequest(`/terminology/drugbank/interactions?ids=${ids.join(',')}`)
      .then(response => {
        dispatch({
          type: 'UPDATE_INTERACTIONS',
          interactions: response
        })
      })
  }

  dispatch({
    type: 'UPDATE_INTERACTIONS',
    interactions: []
  })
  return null
}

export const postMedications =
  (originalMedications, medications, patientId) => dispatch => {
    const updatedMedications = medications.map(med =>
      _(med).omit(_.isUndefined).omit(_.isNull).value())
    const originalMedicationIds = originalMedications.map(med => med.id)
    const newMedicationIds = medications.map(med => med.id)
    const medicationsMarkedFoDeletion = originalMedicationIds
      .filter(item => newMedicationIds.indexOf(item) < 0)
      .map(id => ({
        id,
        _deleted: true
      }))

    return http
      .putRequest(
        `/patients/${patientId}/medications`,
        mapFormToApi(updatedMedications).concat(medicationsMarkedFoDeletion)
      )
      .then(response => {
        dispatch(updateMedications(mapApiToForm(response)))
        dispatch(getInteractions(response))
        dispatch(notify('medications list was updated', false))
      })
  }

export const getMedications = patientId => dispatch => {
  dispatch(assessment())

  return http
    .getRequest(`/patients/${patientId}/medications`)
    .then(response => {
      dispatch(success({ medications: mapApiToForm(response) }))
      dispatch(getInteractions(response))
    })
    .catch(err => dispatch(failure(err)))
}

const getImunnizationsFromResponse = data => {
  const questions = data.group.group[1]
  return questions.question[0].answer[0].valueString.map(
    q => q
  )
}

const updateAssessmentResource =
  (resource, patientId, notifyTitle) => dispatch => {
    dispatch(notify(`Updating ${notifyTitle}.`, false))
    return http
      .postRequest(`/patients/${patientId}/assessments`, resource)
      .then(response => {
        if (notifyTitle === 'Medications') {
          dispatch(
            success({ immunizations: getImunnizationsFromResponse(response) })
          )
          dispatch(notify(`Updated ${notifyTitle} successfully.`, false))
        } else if (notifyTitle === 'ESAS') {
          // Don't do it this way, Leif!
          dispatch(PatientBannerAction.getPatientBanner())
          dispatch(notify(`Updated ${notifyTitle} successfully.`, false))
        } else {
          // includes notifyTitle === "Palliative", "ROS"
          const data = { questionnaireResponse: response || {} }
          dispatch(
            success(
              AssessmentProxy.generateFormFromQuestionnaireResponse(
                data,
                patientId
              )
            )
          )
          dispatch(notify(`Updated ${notifyTitle} successfully.`, false))
        }
      })
      .catch(err => {
        console.error(`Error updating ${notifyTitle}.`, err)
        dispatch(notify(`Error updating ${notifyTitle}.`, true))
        dispatch(failure(err))
      })
  }

export const updateAssessment = (
  formData,
  category,
  patientId,
  notifyTitle,
  currentUser
) => {
  const resource = AssessmentProxy.generateQuestionnaireResponse(
    formData,
    category,
    currentUser
  )

  return updateAssessmentResource(resource, patientId, notifyTitle)
}

export const updateEncounterAssessment = (
  formData,
  category,
  patientId,
  encounterId,
  notifyTitle,
  currentUser
) => {
  const resource = AssessmentProxy.generateQuestionnaireResponse(
    formData,
    category,
    currentUser
  )

  resource.context = { reference: `Encounter/${encounterId}` }

  return updateAssessmentResource(resource, patientId, notifyTitle)
}

export const getEncounterAssessment =
  (patientId, encounterId, category) => dispatch => {
    dispatch(assessment())
    return http
      .getRequest(
        `/patients/${patientId}/assessments?category=${category}&encounter=${encounterId}&top=1`
      )
      .then(assessmentResponse => {
        const data = {
          questionnaireResponse:
            assessmentResponse.entry.length === 0
              ? {}
              : assessmentResponse.entry[0].resource
        }
        dispatch(
          success(
            AssessmentProxy.generateFormFromQuestionnaireResponse(
              data,
              patientId
            )
          )
        )
      })
      .catch(err => dispatch(failure(err)))
  }

export const getAssessment = (patientId, category) => dispatch => {
  dispatch(assessment())
  return http
    .getRequest(`/patients/${patientId}/assessments?category=${category}&top=1`)
    .then(assessmentResponse =>
      Promise.resolve({
        questionnaireResponse:
          assessmentResponse.entry.length === 0
            ? {}
            : assessmentResponse.entry[0].resource
      }))
    .then(data =>
      Promise.resolve(
        AssessmentProxy.generateFormFromQuestionnaireResponse(data, patientId)
      ))
    .then(data => dispatch(success(data)))
    .catch(err => dispatch(failure(err)))
}

function assessment () {
  return {
    type: ASSESSMENT
  }
}

function success (data) {
  return {
    type: ASSESSMENT_SUCCESS,
    questionnaireResponse: data
  }
}

function failure (error) {
  return {
    type: ASSESSMENT_FAILURE,
    error
  }
}
